import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MbaIcon } from '../../../assignment/atoms/mba-icon/mba-icon';
import { bf } from '../../briefing-ui';

/** Numbered list of text inputs with remove buttons and "+ Add item" (do's, don'ts). */
@Component({
  selector: 'mbt-briefing-list-editor',
  imports: [MbaIcon],
  template: `
    <div class="flex flex-col gap-2">
      @for (item of items(); track $index) {
        <div class="flex items-center gap-2">
          <span class="w-5 shrink-0 text-right font-(family-name:--font-display) text-base font-extrabold text-(--fg-3)" aria-hidden="true">{{ $index + 1 }}</span>
          <input type="text" [id]="idPrefix() + '-' + $index" [class]="bf.input + (highlight() && isFlagged(item) ? ' ' + bf.highlight : '')"
            [value]="item" [placeholder]="placeholder()" maxlength="300"
            [attr.aria-label]="label() + ' ' + ($index + 1)" (input)="set($index, $event)" />
          <button type="button" [class]="bf.iconButton" [attr.aria-label]="'Remove ' + label().toLowerCase() + ' ' + ($index + 1)" (click)="remove($index)">
            <mba-icon name="trash-2" size="size-4" />
          </button>
        </div>
      }
      <button type="button" [id]="idPrefix() + '-add'" [class]="bf.addLink" (click)="add()"><mba-icon name="plus" size="size-4" />Add item</button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BriefingListEditor {
  protected readonly bf = bf;

  readonly items = model.required<string[]>();
  readonly label = input.required<string>();
  readonly placeholder = input('');
  /** Prefix for the inputs' ids, so a "Fix" link can focus one. */
  readonly idPrefix = input.required<string>();
  /** Rings empty items and the ones `flag` matches. */
  readonly highlight = input(false);
  readonly flag = input<RegExp | null>(null);

  protected isFlagged(item: string): boolean {
    const flag = this.flag();
    return !item.trim() || (!!flag && flag.test(item));
  }

  protected set(index: number, event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.items.update((list) => list.map((item, i) => (i === index ? value : item)));
  }

  protected remove(index: number): void {
    this.items.update((list) => list.filter((_, i) => i !== index));
  }

  protected add(): void {
    this.items.update((list) => [...list, '']);
    const id = `${this.idPrefix()}-${this.items().length - 1}`;
    setTimeout(() => document.getElementById(id)?.focus());
  }
}
